import React from 'react'
import { useAuthContext } from '../../hooks/useAuthContext'
import { TransactionForm } from '../finance/TransactionForm'
import { useCollection } from '../../hooks/useCollection'
import { TransactionList } from '../finance/TransactionList'

const Dashboard = () => {
  const { user } = useAuthContext();
  const { documents, error } = useCollection(
    'transactions', ["uid", "==", user.uid], ['createdAt', 'desc']
  )
  
  return (
    <div className='flex-1 p-4'>
    <h2 className='text-lg font-bold'>Dashbaord</h2>
    <TransactionForm uid={ user.uid } />
    {documents && <TransactionList  transactions={documents} /> }
    {error && <p>{ error }</p> }
   


    


    </div>
    
  )
}

export default Dashboard